import FilterReportDateItens from "../../../components/filter/reportDateItens/filter";
import reqVenda from "../../../services/reqMultiTenant/reqVenda";
import MainReportMatrix from "../../report/matrix";

const ReportSaleBySeller = (props) => {
	const options = {
		title: "Comissões por Colaborador",
		subTitle:
			"Relatório: Total vendido pelo funcionário e o cálculo de sua comissão baseada no percentual configurado por produto vendido.",
		ident: "collaboratorCommissions",
		identFilter: "filterCollaboratorCommissions",
		identReport: "reportCollaboratorCommissions",
		tableColumns: [
			{ key: "colaborador", label: "Colaborador", align: "left" },
			{ key: "qtde_vendida", label: "Qtde. Vendida", align: "center" },
			{ key: "total_vendido", label: "Total Vendido", align: "center", format: "currency" },
			{ key: "total_comissao", label: "Comissão", align: "center", format: "currency" },
		],
		reportColumns: [
			{ key: "colaborador", label: "Colaborador", align: "left" },
			{ key: "qtde_vendida", label: "Qtde. Vendida", align: "center" },
			{ key: "total_vendido", label: "Total Vendido", align: "right", format: "currency" },
			{ key: "total_comissao", label: "Comissão", align: "right", format: "currency" },
		],
		showTime: false,
		hasActive: false,
		hasSaleType: false,
		hasParam: false,
		parametersDate: [{ id: 1, label: "Data da venda", value: "dtVenda" }],
		parametersFilter: [],
		listDataTotal: [
			{ key: "total_vendido", label: "Volume de Vendas", format: "currency" },
			{ key: "total_comissao", label: "Total de Comissões", format: "currency" },
		],
	};

	const fetch = async (filterData, newPage) => {
		const newFilterData = { ...filterData, page: newPage, perPage: 15 };
		const response = await reqVenda.listColaboradorComissao(newFilterData);
		return response;
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens}></MainReportMatrix>
		</div>
	);
};

export default ReportSaleBySeller;
